import { parseJson } from 'legacy/lut/classes/helpers/JsonHelper'

import { isInstanceOf } from 'core/utils/functions'
import { TThirdPartyValue } from 'onboarding/classes/models/partnerAdditionalInfo'

export const parseThirdPartyValue = (value: string): TThirdPartyValue | null => {
  const parsed = parseJson<TThirdPartyValue>(value)

  return parsed && isInstanceOf<TThirdPartyValue>(parsed, (o) => 'type' in o && 'id' in o)
    ? parsed
    : null
}
